import { Component, ChangeDetectionStrategy } from '@angular/core';

import {
  ApplicationName,
  LogoComponent,
  NavigationBarMenuItem,
  AppMenuItem,
} from '@tiltgroup/web-components';
import { environment } from '@environments/environment';
import { Permission } from '@shared/permission';

@Component({
  selector: 'lt-navigation',
  imports: [LogoComponent],
  templateUrl: './navigation.component.html',
  // Keeps pre-Angular 22 (Default) change detection, which this component was written for.
  // TODO: migrate to OnPush.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent {
  appMenu: AppMenuItem[] = [
    {
      name: 'iTracker',
      link: environment?.links?.itracker,
      iconName: ApplicationName.Itracker,
      permission: Permission.CAN_ACCESS_ITRACKER,
    },
    {
      name: 'Nexus',
      link: environment?.links?.nexus,
      iconName: ApplicationName.Nexus,
      permission: Permission.CAN_ACCESS_NEXUS,
    },
    {
      name: 'Reporting',
      link: environment?.links?.reporting,
      iconName: ApplicationName.Nexus,
      permission: Permission.CAN_ACCESS_REPORTING,
    },
  ];

  menuItems: NavigationBarMenuItem[] = [
    {
      name: 'Home',
      url: '/home',
    },
  ];

  protected readonly Permission = Permission;
}
